import { SerializedError, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { emailAuditLogService } from '@/src/services/http/emailAuditLog'
import type { EmailAuditLog, EmailAuditLogListParams } from '@/src/types/apps/emailAuditTypes'

type State = {
  loading: boolean
  data: EmailAuditLog[]
  count: number
  error: SerializedError | null
}

const initialState: State = {
  loading: false,
  data: [],
  count: 0,
  error: null
}

export const fetchEmailAuditLogs = createAsyncThunk('emailAuditLog/fetch', async (params: EmailAuditLogListParams) => {
  return emailAuditLogService.list(params)
})

const emailAuditLogSlice = createSlice({
  name: 'emailAuditLog',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchEmailAuditLogs.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchEmailAuditLogs.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.items
        state.count = action.payload.count
      })
      .addCase(fetchEmailAuditLogs.rejected, (state, action) => {
        state.loading = false
        state.error = action.error
      })
  }
})

export default emailAuditLogSlice.reducer
